import {makeStyles} from "@mui/styles";
import {Fragment, useEffect, useState} from "react";
import {Autocomplete, FormControl, FormLabel, Grid, InputAdornment, TextField, Typography} from "@mui/material";

const palletType = [
    {name: '48x40', length: '48', width: '40'},
    {name: '48x48', length: '48', width: '48'},
]

const heightType = ['60', '70', '80']

const weightType = ['400', '600', '800', '1000']

const useStyles = makeStyles({
    smallInput: {
        "& .MuiInputBase-input": {
            height: "0px", // Adjust the height as per your preference
            padding: "2px", // Adjust the padding as per your preference
            fontSize: "14px", // Adjust the font size as per your preference
        }
    }
});

export const WordPressQuotePalletList = ({cbHandleShippingDetails, validatedResult, lng}) => {

    const classes = useStyles();

    const [palletDetail, setPalletDetail] = useState({
            type: {
                name: '48x40',
                length: '48',
                width: '40'
            },
            length: '48',
            width: '40',
            height: '60',
            weight: '400',
            lengthUnit: 'in',
            weightUnit: 'lb',
            quantity: "1"
        }
    );

    const handleType = (event, value) => {
        setPalletDetail(prevState => ({
            ...prevState,
            type: value,
            length: value?.length,
            width: value?.width,
        }))
    }

    const handleHeight = (event, value) => {
        setPalletDetail(prevState => ({
            ...prevState,
            height: value
        }))
    }

    const handleWeight = (event, value) => {
        setPalletDetail(prevState => ({
            ...prevState,
            weight: value
        }))
    }

    const handleQuantity = event => {
        const {value} = event.target;
        if (/^\d*\.?\d*$/.test(value)) {
            const maximum = 10;
            setPalletDetail(prevState => ({
                ...prevState,
                quantity: value > (+maximum) ? maximum : value
            }))
        }
    }

    useEffect(() => {
        cbHandleShippingDetails(palletDetail);
    }, [palletDetail]);

    return (
        <Fragment>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '托盘类型' : "Pallet Type"}
                    </FormLabel>
                    <Autocomplete
                        value={palletDetail?.type}
                        fullWidth
                        options={palletType}
                        getOptionLabel={option => option.name}
                        onChange={handleType}
                        renderInput={(params) => <TextField
                            variant="outlined"
                            {...params}
                            className={classes.smallInput}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                        {/* Add your custom adornment here, e.g. an icon or spinner */}
                                        <InputAdornment
                                            position="end"
                                            sx={{maxHeight: 0}}>
                                            {palletDetail?.lengthUnit}
                                        </InputAdornment>
                                    </>
                                ),
                            }}
                            error={validatedResult !== null && !palletDetail?.type?.name}
                            helperText={(validatedResult !== null && !palletDetail?.type?.name) && (lng === 'cn' ? "必填" : "Required")}
                        />}
                        renderOption={(props, option) => (
                            <li {...props}>
                                <Typography style={{fontSize: '12px'}}>
                                    {option?.name}
                                </Typography>
                            </li>
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '高' : "Height"}
                    </FormLabel>
                    <Autocomplete
                        value={palletDetail?.height}
                        fullWidth
                        options={heightType}
                        getOptionLabel={option => option}
                        onChange={handleHeight}
                        renderInput={(params) => <TextField
                            variant="outlined"
                            {...params}
                            className={classes.smallInput}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                        {/* Add your custom adornment here, e.g. an icon or spinner */}
                                        <InputAdornment
                                            position="end"
                                            sx={{maxHeight: 0}}>
                                            {palletDetail?.lengthUnit}
                                        </InputAdornment>
                                    </>
                                ),
                            }}
                            error={validatedResult !== null && (+palletDetail?.height <= 0 || !palletDetail?.height)}
                            helperText={validatedResult !== null && (!palletDetail?.height ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.height <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                        />}
                        renderOption={(props, option) => (
                            <li {...props}>
                                <Typography style={{fontSize: '12px'}}>
                                    {option}
                                </Typography>
                            </li>
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '重量' : "Weight"}
                    </FormLabel>
                    <Autocomplete
                        value={palletDetail?.weight}
                        fullWidth
                        options={weightType}
                        getOptionLabel={option => option}
                        onChange={handleWeight}
                        renderInput={(params) => <TextField
                            variant="outlined"
                            {...params}
                            className={classes.smallInput}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                        {/* Add your custom adornment here, e.g. an icon or spinner */}
                                        <InputAdornment
                                            position="end"
                                            sx={{maxHeight: 0}}>
                                            {palletDetail?.weightUnit}
                                        </InputAdornment>
                                    </>
                                ),
                            }}
                            error={validatedResult !== null && (+palletDetail?.weight <= 0 || !palletDetail?.weight)}
                            helperText={validatedResult !== null && (!palletDetail?.weight ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.weight <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                        />}
                        renderOption={(props, option) => (
                            <li {...props}>
                                <Typography style={{fontSize: '12px'}}>
                                    {option}
                                </Typography>
                            </li>
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 3}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '数量' : "Quantity"}
                    </FormLabel>
                    <TextField
                        value={palletDetail?.quantity}
                        onInput={handleQuantity}
                        fullWidth
                        variant='outlined'
                        type='number'
                        size='small'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        error={validatedResult !== null && (+palletDetail?.quantity <= 0 || !palletDetail?.quantity)}
                        helperText={validatedResult !== null && (!palletDetail?.quantity ? (lng === 'cn' ? "必填" : "Required") : +palletDetail?.quantity <= 0 && (lng === 'cn' ? "无效" : "Invalid"))}
                    />
                </FormControl>
            </Grid>
        </Fragment>
    )
}